// ResumeSection.js
import React from "react";
import { NumberItem } from "../modules/NumberItem";
import { Fade } from "react-awesome-reveal";

const ResumeSection = () => {
	const numberItems = [
		{
			iconClass: "fa fa-rocket",
			number: "10x",
			title: "Accelerated Innovation Tenfold",
		},
		{
			iconClass: "fa fa-flask",
			number: "1.21GW",
			title: "Experimenting with Future Tech Power",
		},
		{
			iconClass: "fa fa-fire-alt",
			number: "1000°C",
			title: "Igniting Cutting-Edge Trends",
		},
		{
			iconClass: "fa fa-lightbulb",
			number: "42",
			title: "Creative Solutions Discovered",
		},
		{
			iconClass: "fa fa-battery-full",
			number: "100%",
			title: "Fully Charged with Bright Ideas",
		},
		{
			iconClass: "fa fa-heartbeat",
			number: "24/7",
			title: "Passion Pumping for Technology",
		},
		{
			iconClass: "fa fa-coffee",
			number: "99%",
			title: "Efficiency Fueled by Coffee",
		},
		{
			iconClass: "fa fa-user-secret",
			number: "007",
			title: "Licensed to Innovate Efficiently",
		},
		{
			iconClass: "fa fa-calculator",
			number: "3.1416",
			title: "Calculating π Times the Genius",
		},
		{
			iconClass: "fa fa-brain",
			number: "200%",
			title: "Enhanced Strategic Thinking",
		},
		{
			iconClass: "fa fa-infinity",
			number: "∞",
			title: "Endless Code Lines Conquered",
		},
		{
			iconClass: "fa fa-globe",
			number: "∞",
			title: "Exploring Infinite Possibilities Worldwide",
		},
		{
			iconClass: "fa fa-user-astronaut",
			number: "5D",
			title: "Leading Teams Beyond Dimensions",
		},
		{
			iconClass: "fa fa-trophy",
			number: "#1",
			title: "Champion of Code Challenges",
		},
		{
			iconClass: "fa fa-smile-wink",
			number: ":)",
			title: "Injecting Fun into Functionality",
		},
	];

	const skills = [
		{ name: "JavaScript", level: 95 },
		{ name: "React.js", level: 90 },
		{ name: "Node.js", level: 90 },
		{ name: "Azure", level: 90 },
		{ name: "Git", level: 90 },
		{ name: "Team Lead", level: 90 },
		{ name: "Sockets", level: 85 },
		{ name: "WebSockets", level: 85 },
		{ name: "SEO Opt.", level: 85 },
		{ name: "Agile Meth", level: 85 },
		{ name: "TensorFlow", level: 85 },
		{ name: "Three.js", level: 75 },
		{ name: "MediaPipe", level: 70 },
		{ name: "AWS", level: 70 },
		{ name: "Docker", level: 70 },
		{ name: "Coffee Brew", level: 100 },
		{ name: "Humor Fun", level: 95 },
	];

	const services = [
		"Full Stack Wizardry",
		"AI-Powered Innovations",
		"Algorithm Alchemy",
		"Agile Project Mastery",
		"Creative Problem Solving",
		"Real-Time Systems Magic",
		"Machine Learning Marvels",
		"UX Enhancements with Flair",
	];

	const education = [
		{
			date: "2017 - 2020",
			degree: "Master of Computer Applications",
			institution: "National Institute of Technology (NIT), Raipur",
		},
		{
			date: "2013 - 2016",
			degree: "Bachelor of Computer Applications",
			institution: "MRSC College, Indore",
		},
	];

	const certificates = [
		{
			name: "Data Structures & Algorithms Guru",
			date: "🏅 Secured 4th Place — Algorithm Ace",
			link: "https://drive.google.com/file/d/1fkOL51uJiTDFodRlhA_Iz0i5DblxXDg9/view?usp=sharing",
		},
		{
			name: "JavaScript Ninja",
			date: "🌟 Top 1% in Mangtas Test — JS Juggler",
			link: "https://drive.google.com/file/d/1Z9NfmqzjHTT3GqWhHpiW1Uch_y0XqIpS/view",
		},
		{
			name: "Full Stack Virtuoso",
			date: "🌟 Top 1% in Mangtas Test — Code Conductor",
			link: "https://drive.google.com/file/d/1HDbhpOiOsjIlAfo1MLym2ewYfgq_eOlR/view",
		},
		{
			name: "C++ Code Crusader",
			date: "🏅 Secured 7th Place — FORK CPP Champion",
			link: "https://drive.google.com/file/d/1W6BJ5cWPX0hjaiW26XcMS9sDajDFwlkP/view?usp=sharing",
		},
	];

	const experience = [
		{
			date: "Sept 2024 - Present",
			position: "Associate Team Lead & Code Maestro",
			company: "Mindfire Solutions",
			companyLink: "https://www.mindfiresolutions.com/",
		},
		{
			date: "Oct 2021 - Sept 2024",
			position: "Senior Software Engineer - Bug Slayer",
			company: "Mindfire Solutions",
			companyLink: "https://www.mindfiresolutions.com/",
		},
		{
			date: "July 2020 - Sept 2021",
			position: "Full Stack Developer - Magic Maker",
			company: "Magical Solutions",
			companyLink: "https://www.magicalsolutions.com/", // Added placeholder link
		},
		{
			date: "Jan 2020 - June 2020",
			position: "Development Intern - Code Apprentice",
			company: "Mindfire Solutions",
			companyLink: "https://www.mindfiresolutions.com/",
		},
	];

	const contacts = [
		{
			iconClass: "fas fa-phone",
			info: "+91 9755 565 810",
			link: "tel:+919755565810",
		},
		{
			iconClass: "fas fa-at",
			info: "lightwalamurtaza5210",
			link: "mailto:lightwalamurtaza5210@gmail.com",
		},
		{
			iconClass: "fas fa-location-arrow",
			info: "571, Sai Paradise, Indore, India",
		},
	];

	return (
		<section
			className="section section-bg section-parallax-2"
			id="resume-section"
			style={{ textAlign: "left" }}
		>
			<div className="container">
				{/* Section Heading */}
				<header className="m-titles">
					<Fade direction="up" triggerOnce delay={200}>
						<h2
							className="m-title"
						>
							My Resume
						</h2>
					</Fade>
				</header>

				<div className="row row-custom">
					<aside className="col-xs-12 col-sm-12 col-md-3 col-lg-3 d-none d-md-block">
						<div className="numbers-items">
							<Fade
								className="numbers-item"
								direction="up"
								triggerOnce
								cascade={true}
								damping={0.2}
							>
								{numberItems.map((item, index) => (
									<NumberItem
										key={index}
										iconClass={item.iconClass}
										number={item.number}
										title={item.title}
									/>
								))}
							</Fade>
						</div>
					</aside>
					<article className="col-xs-12 col-sm-12 col-md-9 col-lg-9 vertical-line">
						{/* Description */}
						<section className="text">
							<Fade
								direction="up"
								style={{ marginBottom: "1.5em" }}
								triggerOnce
								damping={0.5}
								cascade={true}
							>
								<p style={{ textAlign: "justify" }}>
									Elevate Your Projects with <strong>Murtaza Lightwala</strong>{" "}
									– A Passionate and Innovative{" "}
									<strong>Senior Software Engineer</strong> and{" "}
									<strong>Team Lead</strong> with over{" "}
									<strong>4.6 years of experience</strong> in{" "}
									<strong>Backend</strong> and <strong>Web Development</strong>.
								</p>
								<p style={{ textAlign: "justify" }}>
									Driven by a relentless pursuit of mastering new technologies,
									Murtaza excels at unraveling complex problems and building
									robust, scalable solutions. His expertise encompasses
									algorithm and data structure design, implementing
									high-performance applications, and driving business growth
									through technological innovation.
								</p>
								<p style={{ textAlign: "justify" }}>
									<em>
										Technology isn't just my profession; it's my craft. I
										believe in creating solutions that not only work but
										inspire.
									</em>
								</p>
							</Fade>
						</section>

						{/* Skills */}
						<section className="skills-items">
							<Fade direction="up" triggerOnce>
								<div className="p-title" data-animate="active">
									EXPERTISE
								</div>
							</Fade>
							<Fade
								direction="up"
								className="skills-item"
								triggerOnce
								damping={0.2}
								cascade={true}
							>
								{skills.map((skill, index) => (
									<div className="skills-item" key={index}>
										<div className="name">{skill.name}</div>
										<div className={`dots dots-${skill.level}`}>
											<div className="dots-row">
												{[...Array(10)].map((_, i) => (
													<div
														key={i}
														className={`dot ${
															i < skill.level / 10 ? "active" : ""
														}`}
													/>
												))}
											</div>
										</div>
										<div className="value">
											<span className="num">{skill.level}%</span>
										</div>
									</div>
								))}
							</Fade>
						</section>

						{/* Services */}
						<Fade direction="up" triggerOnce>
							<section className="p-title">SKILLS</section>
						</Fade>
						<section className="services-items">
							<Fade
								direction="up"
								className="services-col"
								triggerOnce
								damping={0.5}
								cascade={true}
							>
								{services.map((service, index) => (
									<div key={index}>
										<div className="services-item">
											<div className="title">{service}</div>
										</div>
									</div>
								))}
							</Fade>
						</section>

						{/* History */}
						<section className="history-left">
							<div className="history-items">
								<Fade direction="up" triggerOnce>
									<div className="p-title" data-animate="active">
										EDUCATION
									</div>
								</Fade>
								<Fade
									className="history-item"
									direction="up"
									triggerOnce
									cascade={true}
									damping={0.5}
								>
									{education.map((item, index) => (
										<div className="history-item" key={index}>
											<div className="date">{item.date}</div>
											<div className="name">{item.degree}</div>
											<div className="subname">{item.institution}</div>
										</div>
									))}
								</Fade>
							</div>

							<div className="history-items">
								<Fade direction="up" triggerOnce>
									<div className="p-title " data-animate="active">
										CERTIFICATES
									</div>
								</Fade>
								<Fade
									direction="up"
									className="history-item"
									triggerOnce
									damping={0.5}
									cascade={true}
								>
									{certificates.map((cert, index) => (
										<div className="history-item" key={index}>
											<div
												className="name"
												dangerouslySetInnerHTML={{ __html: cert.name }}
											/>
											<div
												className="date"
												dangerouslySetInnerHTML={{ __html: cert.date }}
											/>
											<div className="text">
												<a
													href={cert.link}
													target="_blank"
													rel="noopener noreferrer"
												>
													Certificate Link
												</a>
											</div>
										</div>
									))}
								</Fade>
							</div>
						</section>

						<section className="history-right">
							<div className="history-items">
								<Fade direction="up" triggerOnce>
									<div className="p-title" data-animate="active">
										EXPERIENCE
									</div>
								</Fade>
								<Fade
									direction="up"
									className="history-item"
									triggerOnce
									damping={0.5}
									cascade={true}
								>
									{experience.map((exp, index) => (
										<div className="history-item" key={index}>
											<div className="date">{exp.date}</div>
											<div className="name">{exp.position}</div>
											<div className="subname">
												{exp.companyLink ? (
													<a
														href={exp.companyLink}
														target="_blank"
														rel="noopener noreferrer"
													>
														{exp.company}
													</a>
												) : (
													exp.company
												)}
											</div>
										</div>
									))}
								</Fade>
							</div>

							<div className="history-items">
								<Fade direction="up" triggerOnce>
									<div className="p-title">Contact Me</div>
								</Fade>
								<Fade
									direction="up"
									className="history-item"
									triggerOnce
									damping={0.5}
									cascade={true}
								>
									{contacts.map((contact, index) => (
										<div className="history-item" key={index}>
											<div className="name">
												<i aria-hidden="true" className={contact.iconClass}></i>
											</div>
											<div className="subname" style={{ fontWeight: 400 }}>
												{contact.link ? (
													<a
														href={contact.link}
														style={{ textDecoration: "none" }}
													>
														{contact.info}
													</a>
												) : (
													contact.info
												)}
											</div>
										</div>
									))}
								</Fade>
							</div>
						</section>

						<div className="clear"></div>
					</article>
				</div>
			</div>
		</section>
	);
};

export default ResumeSection;
